import { DSCardWrapper } from "@components/design-system/molecules";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createPortal } from "react-dom";

import { useCompanionModalContainer } from "./CompanionModalContainerContext";

export default function CompanionModal({ title, children, onClose }) {
  const contextContainer = useCompanionModalContainer();
  const target = contextContainer ?? document.body;

  if (!target) {
    return null;
  }

  return createPortal(
    <div className="absolute inset-0 z-modal flex flex-col items-center justify-center bg-black/80 p-lg">
      <DSCardWrapper
        variant="modal"
        padding="p-md"
        dataTestId="companion-modal"
      >
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="shrink-0 w-3 h-3 flex items-center justify-center text-primary hover:text-secondary transition-colors"
            aria-label="Close modal"
            data-testid="companion-modal-close"
          >
            <FontAwesomeIcon icon={faXmark} className="w-3 h-3" />
          </button>
        </div>
        <div className="flex flex-col gap-sm text-left">
          <h3 className="font-companion">{title}</h3>
          <div>{children}</div>
        </div>
      </DSCardWrapper>
    </div>,
    target,
  );
}
